import React from 'react';

import clsx from 'clsx';

import * as classes from './If.module.css';

const If = ({
    id,
    ...props
}) => {

    return (
        <span style={{ display: 'flex', alignItems: 'center' }} id={`${id}-if-block-start-BOB`}>
            <React.Fragment>&nbsp;</React.Fragment>
            <div data-allow-insert={false} id={`${id}-if-block-start-BOB`}>
                <div data-allow-insert={false} className={classes.IfBlock}>
                    <div id={`${id}-if-body`} data-allow-insert={false} className={classes.BlockContainer}>
                        <div
                            data-parentId={'123'}
                            data-allow-insert={false}
                            className={classes.BlockTitle}
                        >
                            IF
                        </div>
                        <div data-parentId={`${id}-if-block-BOB`} id="if-block-body" className={classes.InLineBlock}>
                            <React.Fragment>&nbsp;</React.Fragment>
                        </div>
                        <div id="if-block-end" data-allow-insert={false} className={classes.BlockTitleAlt}>
                            THEN
                        </div>
                        <div id="if-block-then" className={classes.InLineBlock}>
                            <React.Fragment id="if-block">&nbsp;</React.Fragment>
                        </div>
                        <div id="if-block-then-end" />
                    </div>
                    <span
                        id={`${id}-delete`}
                        data-allow-insert={false}
                        role="none"
                        class={clsx('material-icons-outlined', classes.DeleteIcon)}
                    >
                        delete
                    </span>
                </div>
                <div
                    data-allow-insert={false}
                    className={classes.ButtonContainer}
                    role="none"
                >
                    <span data-allow-insert={false} role="none"><button id={`${id}-else`} className={classes.Button}>ELSE</button></span>
                    <button data-allow-insert={false} id={`${id}-else-if`} className={classes.Button}>ELSE IF</button>
                </div>
            </div>
            <React.Fragment>&nbsp;</React.Fragment>
        </span>
    );
};

export default If;
